import {Link, useLocation} from 'react-router';
import {SocialAuthSection} from './social-auth-section';
import {AuthLayout} from './auth-layout/auth-layout';
import {Trans} from '@ui/i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';
import {useSettings} from '@ui/settings/use-settings';
import {MobileOtpLoginForm} from './mobile-otp-login-form';
import {SiteConfigContextValue} from '../../core/settings/site-config-context';
import {LinkStyle} from '@ui/buttons/external-link';

interface Props {
  onTwoFactorChallenge: () => void;
}
export function LoginPage({}: Props) {
  const {pathname} = useLocation();

  const isWorkspaceLogin = pathname.includes('workspace');

  const {branding, social} = useSettings();

  const heading = isWorkspaceLogin ? (
    <Trans
      values={{siteName: branding?.site_name}}
      message="To join your team on :siteName, login to your account"
    />
  ) : (
    <Trans message="Sign in to your account" />
  );

  return (
    <AuthLayout heading={heading} >
      <StaticPageTitle>
        <Trans message="Login" />
      </StaticPageTitle>
      <MobileOtpLoginForm />
      <div className="mt-14 text-center text-sm">
        <Link className={LinkStyle} to="/forgot-phone-number">
          <Trans message="Forgot phone number?" />
        </Link>
      </div>
      <SocialAuthSection
        dividerMessage={
          social?.compact_buttons ? (
            <Trans message="Or sign in with" />
          ) : (
            <Trans message="OR" />
          )
        }
      />
    </AuthLayout>
  );
}

export function getDemoFormDefaults(siteConfig: SiteConfigContextValue) {
  if (siteConfig.demo.loginPageDefaults === 'randomAccount') {
    // random number between 0 and 100, padded to 3 digits
    const number = Math.floor(Math.random() * 100) + 1;
    const paddedNumber = String(number).padStart(3, '0');
    return {
      email: `admin@demo${paddedNumber}.com`,
      password: 'admin',
    };
  } else {
    return {
      email: siteConfig.demo.email ?? 'admin@admin.com',
      password: siteConfig.demo.password ?? 'admin',
    };
  }
}
